import { useQuery } from "react-query";
import { getStudentSubscriptionsSubjects } from "../services/school/student/getStudents";
import { PagedRequestType } from "../types/PagedResults";
import { Key_student_subscriptions_subjects } from "../utils/constants";

export const useGetStudentsSubscriptionSubjectsQuery = (data: PagedRequestType, options:any= null) =>
  useQuery(
    [Key_student_subscriptions_subjects, JSON.stringify(data)],
    () => getStudentSubscriptionsSubjects(data),
    options?{...options}:{}
  );

  
